import * as React from 'react';

export interface Reporter {
  reportException: (err: Error, additionalData?: object) => void

  reportWarning: (message: string) => void
}

export class EmptyReporter implements Reporter {
  reportException(err: Error, additionalData?: object) {

  }

  reportWarning(message: string) {

  }
}


export const ErrorReporting: React.Context<Reporter> = React.createContext(new EmptyReporter());
